const layout2Settings = {
  header: { show: true },
  searchBox: { open: false },
  secondarySidebar: { show: false },
  leftSidebar: {
    open: true,
    secondaryNavOpen: false,
    theme: "sidebar-gradient-black-blue"
  }
};

export default layout2Settings;
